$().ready(function () {

})





window.onscroll = function () {
    if ($(document).scrollTop() >= 100) {
        $('.header_box').addClass("header_fixed_box");
        $('.index_optbtn').css({ 'z-index': -1 });
    } else {
        $('.header_box').removeClass("header_fixed_box");
        $('.index_optbtn').css({ 'z-index': 200 });
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/js.js